import Box from '@mui/material/Box';
import {SxProps, Theme} from '@mui/material/styles';
import {
  getRfpStatus,
  RfpStatusInput,
  StatusTone,
  toneColors,
} from './rfpStatus';
import {fonts, radius} from './tokens';

interface StatusChipProps {
  // An RFP / service-order shaped object; label + tone derive via
  // getRfpStatus. Takes precedence over `label`/`tone` when set.
  status?: RfpStatusInput | null;
  // ...or a direct label + tone (tone defaults to 'neutral').
  label?: string;
  tone?: StatusTone;
  sx?: SxProps<Theme>;
}

// Tokenized status pill -- the web port of the mobile kit StatusChip. Unlike
// common/StatusChip.tsx (which only knows Bid + SiteVisit shapes and colors
// FUNDED three different ways), this renders any status from the one shared
// rfpStatus model, synchronously (no useEffect flash).
const StatusChip = ({status, label, tone, sx}: StatusChipProps) => {
  const resolved = status
    ? getRfpStatus(status)
    : {label: label ?? '', tone: tone ?? ('neutral' as StatusTone)};

  if (!resolved.label) {
    return null;
  }

  const colors = toneColors[resolved.tone];

  return (
    <Box
      component="span"
      sx={[
        {
          display: 'inline-flex',
          alignItems: 'center',
          padding: '5px 10px',
          borderRadius: `${radius.pill}px`,
          backgroundColor: colors.bg,
          color: colors.fg,
          fontFamily: fonts.sans,
          fontSize: 12,
          fontWeight: 600,
          lineHeight: 1,
          letterSpacing: '0.4px',
          textTransform: 'uppercase',
          whiteSpace: 'nowrap',
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}>
      {resolved.label}
    </Box>
  );
};

export default StatusChip;
